export const YTD = "YTD"
export const ONE_MONTH = "ONE_MONTH"
export const SIX_MONTHS = "SIX_MONTHS"
export const ONE_YEAR = "ONE_YEAR"
export const THREE_YEARS = "THREE_YEARS"
export const FIVE_YEARS = "FIVE_YEARS"
export const SINCE_CREATION = "SINCE_CREATION"

export const WIDGET_PERIODS = {
  YTD,
  ONE_MONTH,
  SIX_MONTHS,
  ONE_YEAR,
  THREE_YEARS,
  FIVE_YEARS,
  SINCE_CREATION
}
